import { render, staticRenderFns } from "./OrbitPreviousRoundContent.vue?vue&type=template&id=7312f8be&scoped=true"
import script from "./OrbitPreviousRoundContent.vue?vue&type=script&lang=ts"
export * from "./OrbitPreviousRoundContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312f8be",
  null
  
)

export default component.exports